/* @flow */
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import protonesUtils from 'utils/protones';
import _ from 'lodash';
import type { Translate, SimplifiedTrack, SimplifiedMedia, Person } from 'types';

import styles from './styles.module.scss';

type Props = {
  track: SimplifiedTrack,
  medias?: SimplifiedMedia[],
  onMediaClick?: (media: SimplifiedMedia) => mixed,
  onPerformerClick?: (performer: Person) => mixed,
  onAuthorClick?: (author: Person) => mixed,
  t: Translate,
};

const TrackListRowAccordionDetail = ({
  track,
  medias,
  onMediaClick,
  onPerformerClick,
  onAuthorClick,
  t,
}: Props) => {
  const mediaWithLowestYear = _.minBy(medias, x => x.year) || {};
  const opera = _.get(track, 'opera.title');
  const authors = _.get(track, 'authors', []);
  const catalog =
    track.catalog && `${_.get(track, 'catalog.description')} (${_.get(track, 'catalog.code')})`;
  const metre = track.metre;
  const tags = track.tags;
  const genre = track.genre;
  const orchestration = track.orchestration;
  const tempo = track.tempo;
  const tones = track.tones;
  const bpm = track.bpm;
  return (
    <div className={styles.container}>
      <TrackListRowAccordionDetailSection label={t('YEAR')} value={mediaWithLowestYear.year} />
      <TrackListRowAccordionDetailSection label={t('OPERA')} value={opera} />
      <TrackListRowAccordionDetailSection
        label={t('AUTHORS')}
        value={authors}
        onValueClick={onAuthorClick}
        valueDisplay={protonesUtils.getPersonLabel}
      />
      <TrackListRowAccordionDetailSection
        label={t('SUPPORTS')}
        value={medias}
        valueDisplay={protonesUtils.getMediaLabel}
        onValueClick={onMediaClick}
      />
      <TrackListRowAccordionDetailSection label={t('CATALOG')} value={catalog} />
      <TrackListRowAccordionDetailSection label={t('TAGS')} value={tags} />
      <TrackListRowAccordionDetailSection label={t('GENRE')} value={genre} />
      <TrackListRowAccordionDetailSection label={t('ORCHESTRATION')} value={orchestration} />
      <TrackListRowAccordionDetailSection label={t('METRE')} value={metre} />
      <TrackListRowAccordionDetailSection label={t('TEMPO')} value={tempo} />
      <TrackListRowAccordionDetailSection label={t('TONES')} value={tones} />
      <TrackListRowAccordionDetailSection label={t('BPM')} value={bpm} />
    </div>
  );
};

type SectionProps = {
  label: string,
  value: any, // string | number | string[] | number[],
  valueDisplay?: (value: any) => React.Node,
  onValueClick?: (value: any) => mixed,
};
const TrackListRowAccordionDetailSection = (props: SectionProps) => {
  const { label, value, onValueClick, valueDisplay = _ => _ } = props;
  const isValueArray = Array.isArray(value);
  if (!value) {
    return null;
  }
  if (isValueArray && value.length === 0) {
    return null;
  }
  return (
    <div className={styles.sectionContainer}>
      <div className={styles.sectionContent}>
        <div className={styles.sectionHeader}>
          <b>{`${label}:`}</b>
        </div>
        <div className={styles.sectionBody}>
          {Array.isArray(value) ? (
            value.map((x, index) => (
              <p
                className={onValueClick ? styles.sectionValueClickable : styles.sectionValue}
                key={`TrackListAccordionDetailSection_${x}_${index}`}
                onClick={() => (onValueClick ? onValueClick(x) : undefined)}
              >
                {valueDisplay(x)}
              </p>
            ))
          ) : (
            <p
              className={onValueClick ? styles.sectionValueClickable : styles.sectionValue}
              onClick={() => (onValueClick ? onValueClick(value) : undefined)}
            >
              {valueDisplay(value)}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(TrackListRowAccordionDetail);
